export enum IDImpediment {
  Sposo = '1',
  Sposa = '2',
  Entrambi = '3',
}
